// removed by extract-text-webpack-plugin
module.exports = {"pre-selection-failed-page":"_3ct-PBWGTYFehAQZw8nHnJ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/PreSelection/Failed/style.scss
// module id = 2603
// module chunks = 1